import script from "./ElementLabel.vue?vue&type=script&lang=js"
export * from "./ElementLabel.vue?vue&type=script&lang=js"

import "./ElementLabel.vue?vue&type=style&index=0&id=4f55029c&lang=scss"

const __exports__ = script;

export default __exports__